import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import SubAllocationTableHeader from '../SubAllocationTableHeader'
import AdUnitsMultilevelSelect from '../../AdUnitsMultilevelSelect'
import ErrorMessage from '../../../../../../../../../../../../components/Form/ErrorMessage'

import { AD_UNITS, IS_SUB_ALLOCATION } from '../../../../fields'

const SelectedAdUnitsTable = ({ formik, topParentAdUnitId, allocationPriceLabel }) => {
  const { t } = useTranslation()
  const { values, errors, touched } = formik

  const adUnitsError = errors[AD_UNITS]
  const adUnitsTouched = touched[AD_UNITS]

  const showAdUnitsError = adUnitsError && typeof adUnitsError === 'string' && adUnitsTouched

  const hasSelectedItems = values[AD_UNITS].length > 0

  return (
    <FieldLabelWrapper label={hasSelectedItems ? 'Selected ad units' : ''}>
      {hasSelectedItems && values[IS_SUB_ALLOCATION] && (
        <SubAllocationTableHeader title={t('Ad Unit')} allocationPriceLabel={allocationPriceLabel} />
      )}
      <AdUnitsMultilevelSelect formik={formik} topParentAdUnitId={topParentAdUnitId} />
      {showAdUnitsError && <ErrorMessage error={adUnitsError} />}
    </FieldLabelWrapper>
  )
}

export default SelectedAdUnitsTable
